import React, { useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import md5 from 'md5';
import queryString from 'query-string';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Divider from '@material-ui/core/Divider';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Text } from 'recharts';
import PublicFooter from '../../components/PublicFooter';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { signIn, sendLogin } from '../../auth/Auth';
import { getAccounts } from '../../actions/Accounts';
import { saveCognitoUser } from '../../actions/CognitoUser';
import { updateToken, removeToken } from '../../libs/apis/UserApi';
import RequiredButton from '../../components/atoms/RequiredButton';
import PublicHeader from '../../components/PublicHeader';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    maxWidth: 375,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: 12
    // border: '1px solid #ccc'
  },
  page: {
    display: 'flex',
    flexDirection: 'column'
  },
  titlePlatform: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 56,
    fontSize: 15,
    fontWeight: 'bold',
    backgroundColor: theme.palette.primary.main,
    color: '#ffffff',
    marginBottom: 10
  },
  titleDiv: {
    textAlign: 'center',
    marginTop: 10
  },
  titleGroup: {
    marginTop: 15,
    marginBottom: 15,
    display: 'flex',
    alignItems: 'flex-start'
  },
  titleGroup2: {
    marginTop: 40,
    marginBottom: 15,
    display: 'flex',
    alignItems: 'flex-start'
  },
  icon: {
    margin: theme.spacing(1),
    width: 307,
    maxWidth: '95%'
  },
  iconOpenDoc: {
    width: 16
  },
  iconButton: {
    height: 23
  },
  iconButton2: {
    height: 35
  },
  icon2: {
    width: '218px'
  },
  paper2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  paperInDiv: {
    padding: 20
  },
  groupRegisterButton: {
    marginTop: theme.spacing(2),
    fontSize: '0.675rem'
  },
  banner: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  },
  form: {
    marginTop: theme.spacing(2)
  },
  submit: {
    marginBottom: 20,
    fontSize: 14
  },
  linkDiv: {
    paddingLeft: '28px',
    margin: '5px 0px'
  },
  link: {
    display: 'flex',
    fontSize: 14
  },
  font12: {
    fontSize: 12
  },
  font14: {
    fontSize: 14
  },
  font20: {
    fontSize: 20
  },
  groupDoc: {
    paddingTop: 40,
    paddingBottom: 40
  },
  groupBottom: {
    paddingTop: 40
  },
  btnBottom: {
    height: 50,
    marginBottom: 15,
    fontSize: 14,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)'
  },
  bold: {
    fontWeight: 'bold'
  },
  blockQA: {
    position: 'relative',
    paddingTop: '2px',
    paddingLeft: '28px'
  },
  blockQALast: {
    marginTop: '10px',
    marginBottom: '30px'
  },
  iconQA: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '24px',
    height: '24px',
    padding: '3px 0px 1px 0px',
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    fontFamily: 'Helvetica',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '18px',
    color: '#F7F7F7',
    textShadow:
      `1px 0 ${theme.palette.primary.main}, ` +
      `-1px 0 ${theme.palette.primary.main}, ` +
      `0 1px ${theme.palette.primary.main}, ` +
      `0 -1px ${theme.palette.primary.main}, ` +
      `1px 1px ${theme.palette.primary.main}, ` +
      `-1px -1px ${theme.palette.primary.main}, ` +
      `1px -1px ${theme.palette.primary.main}, ` +
      `-1px 1px ${theme.palette.primary.main}`,
    textAlign: 'center'
  },
  textQA: {
    fontSize: '14px'
  },
  filledBackground: {
    backgroundColor: theme.palette.primary.main
  },
  logoFukuoka: {
    textAlign: 'center',
    marginTop: '18px',
    marginBottom: '16px'
  },
  logoTextFukuoka: {
    textAlign: 'center',
    marginBottom: '3px'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      detail: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators({ saveCognitoUser, getAccounts }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('email', 'setEmail', ''),
  withState('password', 'setPassword', ''),
  withState('isFukuoka', 'setIsFukuoka', false),
  withState('isSuita', 'setIsSuita', false),
  withState('isNishiwaki', 'setIsNishiwaki', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  })
);

const login = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleRedirect,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    email,
    setEmail,
    password,
    setPassword,
    isFukuoka,
    setIsFukuoka,
    isSuita,
    setIsSuita,
    isNishiwaki,
    setIsNishiwaki
  }) => {
    const url = window.location.search;
    const params = queryString.parse(url);
    const cognitoUserIdShop = params.cui;
    const shopName = params.sn;
    const shopId = params.sid;
    const loginToShop = params.lts;

    useEffect(() => {
      sessionStorage.removeItem('flagFirstLogginShop');

      if (params.key) {
        window.location.href = `${
          process.env.REACT_APP_EDUCATION_SYSTEM_MANAGE_WEB
        }/${url}`;
        return;
      }

      const link = document.querySelector("link[rel~='icon']");
      if (params.key === 'naraigoto') {
        document.title = '福岡市子ども習い事応援事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_fukuoka_icon.png`;
        setIsFukuoka(true);
        setIsSuita(false);
        setIsNishiwaki(false);
      } else if (params.key === 'suitanaraigoto') {
        document.title = '吹田市子供の習い事費用助成事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_suita_icon.ico`;
        setIsFukuoka(false);
        setIsSuita(true);
        setIsNishiwaki(false);
      } else if (params.key === 'nishiwaki') {
        document.title = '西脇市こども未来応援事業';
        link.href = `${process.env.PUBLIC_URL}/images/logo_nishiwaki.ico`;
        setIsFukuoka(false);
        setIsSuita(false);
        setIsNishiwaki(true);
      } else {
        sessionStorage.removeItem('siteKey');
        document.title = 'ごちめし';
        link.href = `favicon.ico`;
        setIsFukuoka(false);
        setIsSuita(false);
        setIsNishiwaki(false);
      }
      // remove token
      const currentToken = localStorage.getItem('firebaseToken');
      removeToken({
        pushToken: currentToken
      })
        .then(() => {
          console.log('remove token success');
        })
        .catch(() => {
          console.log('remove token failed');
        });

      Auth.signOut();
    }, []);

    const onPressSignIn = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const md5Pass = md5(password);
      localStorage.removeItem('cognitoUserId');
      if (!loginToShop) {
        signIn(email, password)
          .then(async user => {
            const cognitoUserId = user.getUsername();
            await actions.saveCognitoUser(cognitoUserId);
            const { jwtToken } = user.signInUserSession.accessToken;
            const requestHeaders = {
              Authorization: `Bearer ${jwtToken}`,
              'X-Access-Token': `Bearer ${jwtToken}`
            };
            await actions
              .getAccounts({ cognitoUserId }, requestHeaders)
              .then(data => {
                if (data.payload.fukuokaFlag) {
                  const urlEducationSystem = `${
                    process.env.REACT_APP_EDUCATION_SYSTEM_MANAGE_WEB
                  }/${url}`;

                  updateLoading(false);
                  updateOpenProgress(false);
                  setResultMessage('');
                  window.location.href = urlEducationSystem;
                  return;
                }

                checkSession(data);

                console.log(`data:${JSON.stringify(data)}`);
                // update token to server
                const currentToken = localStorage.getItem('firebaseToken');
                console.log('currentToken:', currentToken);
                if (currentToken) {
                  updateToken({
                    pushToken: currentToken
                  })
                    .then(() => {
                      // update success
                      console.log('update token success');
                    })
                    .catch(() => {
                      // update error
                      console.log('update token failed');
                    });
                }

                updateOpenProgress(false);
                setResultMessage('');
                updateLoading(false);
                if (data.payload.status === 'FORCE_PASS_CHANGE') {
                  handleRedirect(`/force_passowrd_change`);
                } else if (data.payload.role === 'GROUP') {
                  if (
                    data.payload.groupAccountStatus &&
                    !data.payload.groupAccountStatus.status
                  ) {
                    handleRedirect('/release_group');
                  } else {
                    handleRedirect('/home_group');
                  }
                } else if (data.payload.role === 'SHOP') {
                  if (
                    data.payload.accountStatus &&
                    !data.payload.accountStatus.status
                  ) {
                    handleRedirect('/release_step');
                  } else {
                    handleRedirect('/home');
                  }
                } else {
                  handleRedirect('/shops');
                }
              });
          })
          .catch(() => {
            setResultMessage('ログインに失敗しました。');
            updateLoading(false);
          });
      } else if (cognitoUserIdShop) {
        const cognitoUserId = cognitoUserIdShop;
        localStorage.setItem('cognitoUserId', cognitoUserId);
        const requestHeaders = {
          'X-Secret-Password': md5Pass
        };
        actions.getAccounts({ cognitoUserId }, requestHeaders).then(data => {
          if (data.error) {
            setResultMessage('ログインに失敗しました。');
            updateLoading(false);
            return;
          }

          if (data.payload.fukuokaFlag) {
            const urlEducationSystem =
              process.env.REACT_APP_EDUCATION_SYSTEM_MANAGE_WEB;
            updateLoading(false);
            updateOpenProgress(false);
            setResultMessage('');
            window.location.href = urlEducationSystem;
            return;
          }

          checkSession(data);
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          if (data.payload.status === 'FORCE_PASS_CHANGE') {
            handleRedirect(`/force_passowrd_change`);
          } else if (
            data.payload.accountStatus &&
            !data.payload.accountStatus.status
          ) {
            handleRedirect('/release_step');
          } else if (data.payload.role === 'GROUP') {
            handleRedirect('/home_group');
          } else if (data.payload.role === 'SHOP') {
            handleRedirect('/home');
          } else {
            handleRedirect('/shops');
          }
        });
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    const getUrlForgotPassword = () => {
      let urlForgotPassword = '/forgot_password';

      if (isFukuoka) {
        urlForgotPassword += '?key=naraigoto';
      } else if (isSuita) {
        urlForgotPassword += '?key=suitanaraigoto';
      } else if (isNishiwaki) {
        urlForgotPassword += '?key=nishiwaki';
      }

      return urlForgotPassword;
    };

    const getUrlRedirect = () => {
      let urlRedirect = 'https://shop-guide.gochimeshi.com/';

      if (isFukuoka) {
        urlRedirect = 'http://gigi-project.net/kodomonaraigoto-fukuoka';
      } else if (isSuita) {
        urlRedirect = 'http://gigi-project.net/kodomonaraigoto-suita/';
      } else if (isNishiwaki) {
        urlRedirect =
          'https://kodomomirai-nishiwaki.jp/category-classroom/manual/';
      }

      return urlRedirect;
    };

    function getLogo() {
      let logoElement = <div />;

      if (isFukuoka) {
        logoElement = (
          <>
            <div className={classes.logoFukuoka}>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo_fukuoka.png`}
                alt="Logo Fukuoka"
                width={150}
              />
            </div>
            <div className={classes.logoTextFukuoka}>
              <img
                src={`${process.env.PUBLIC_URL}/images/logo_text_fukuoka.png`}
                alt="Logo Text Fukuoka"
                width={150}
              />
            </div>
          </>
        );
      } else if (isSuita) {
        logoElement = (
          <div className={classes.logoFukuoka}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo_suita.png`}
              alt="Logo Fukuoka"
              width={150}
            />
          </div>
        );
      } else if (isNishiwaki) {
        logoElement = (
          <div className={classes.logoFukuoka}>
            <img
              src={`${process.env.PUBLIC_URL}/images/logo_nishiwaki.png`}
              alt="Logo Nishiwaki"
              width={150}
            />
          </div>
        );
      }

      return logoElement;
    }

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <PublicHeader />
        <div className={classes.page}>
          {/* <div className={classes.titlePlatform}>
            GOCHIプラットフォーム管理システム
          </div> */}
          {getLogo()}
          <div className={classes.titleGroup}>
            <Typography className={classes.font20}>ログイン</Typography>
          </div>
          <Paper className={classes.paper} elevation={1}>
            <div>
              <form className={classes.form} noValidate>
                <div className={classes.paperInDiv}>
                  <RequiredButton />
                  {loginToShop && cognitoUserIdShop ? (
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      value={shopName || shopId}
                      disabled
                      id="email"
                      label="メールアドレス"
                      name="email"
                      autoComplete="email"
                    />
                  ) : (
                    <TextField
                      margin="normal"
                      required
                      fullWidth
                      id="email"
                      label="メールアドレス"
                      name="email"
                      autoComplete="email"
                      autoFocus
                      onChange={e => {
                        setEmail(e.target.value);
                      }}
                    />
                  )}
                </div>
                <Divider />
                <div className={classes.paperInDiv}>
                  <RequiredButton />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="パスワード"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    onChange={e => {
                      setPassword(e.target.value);
                    }}
                  />
                  {loginToShop && cognitoUserIdShop ? (
                    <></>
                  ) : (
                    <>
                      <div>
                        パスワードは、英大文字・英小文字・数字全てを含め、8文字以上です
                      </div>
                    </>
                  )}
                </div>
                <Divider />
                <div className={classes.paperInDiv}>
                  <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={onPressSignIn}
                  >
                    ログイン
                  </Button>
                  {loginToShop && cognitoUserIdShop ? (
                    <></>
                  ) : (
                    <>
                      <div>
                        <Button
                          fullWidth
                          color="primary"
                          onClick={() => {
                            handleRedirect(getUrlForgotPassword());
                          }}
                          className={classes.font14}
                        >
                          パスワードをお忘れですか？
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </form>
            </div>
          </Paper>
          {loginToShop && cognitoUserIdShop ? (
            // <Typography align="center">店舗としてログイン</Typography>
            <></>
          ) : (
            <>
              {!isFukuoka && !isSuita && !isNishiwaki && (
                <>
                  <div className={classes.titleGroup2}>
                    <Typography className={classes.font20}>
                      アカウントをお持ちでない方はこちら
                    </Typography>
                  </div>
                  <Paper className={classes.paper} elevation={1}>
                    <div className={classes.paperInDiv}>
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleRedirect('/accounts');
                        }}
                        className={classes.font14}
                      >
                        アカウント登録はこちら
                      </Button>
                      <div className={classes.titleGroup2}>
                        <Typography className={classes.font12}>
                          複数店舗をまめて登録したい方はこちら
                        </Typography>
                      </div>
                      <Button
                        fullWidth
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          handleRedirect('/register_group');
                        }}
                        className={classes.font14}
                      >
                        グループアカウント登録
                      </Button>
                    </div>
                  </Paper>
                </>
              )}
              <div className={classes.groupDoc}>
                {!isFukuoka && !isSuita && !isNishiwaki && (
                  <>
                    <div className={classes.blockQA}>
                      <div
                        className={`${classes.iconQA} ${
                          classes.filledBackground
                        }`}
                      >
                        Q
                      </div>
                      <div className={classes.textQA}>
                        GOCHIプラットフォームとは？
                      </div>
                    </div>
                    <div
                      className={`${classes.blockQA} ${classes.blockQALast}`}
                    >
                      <div className={classes.iconQA}>A</div>
                      <div className={classes.textQA}>
                        <div>
                          GOCHIプラットフォーム（通称：「GOCHI」）とは、店舗のメニューを電子チケットにしてweb上でお客様にご購入いただくサービスです。
                        </div>
                        <div>
                          ギフトや社食・キャンペーンなど、お客様がお客様をよび、あなたのお店に送客を促す仕組みです。
                        </div>
                        <div>
                          「ごちめし」「さきめし」「社食ごちめし」などのサービスを展開しております。
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {/* <div className={classes.linkDiv}>
                  <Link
                    href="https://docs.google.com/document/d/1Ogk973Kx_uacU9PSDNUUKSLxcAZcCM-RgcAVCzxJJ3s/edit?usp=sharing"
                    target="_blank"
                    className={classes.link}
                  >
                    <Text className={classes.bold}>
                      さきめし/ごちめし登録マニュアルは こちら
                    </Text>
                    <OpenInNewIcon className={classes.iconOpenDoc} />
                  </Link>
                </div> */}
                <div className={classes.linkDiv}>
                  <Link
                    href={getUrlRedirect()}
                    target="_blank"
                    className={classes.link}
                  >
                    <Text className={classes.bold}>
                      FAQ・各種マニュアルはこちら
                    </Text>
                    <OpenInNewIcon className={classes.iconOpenDoc} />
                  </Link>
                </div>
              </div>
              {!isFukuoka && !isSuita && !isNishiwaki && (
                <>
                  {' '}
                  <Divider />
                  <div className={classes.groupBottom}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="default"
                      onClick={() =>
                        window.open('https://gochi.online/', '_blank')
                      }
                      className={classes.btnBottom}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/text-logo1.svg`}
                        alt="ごちめし"
                        className={classes.iconButton}
                      />
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="default"
                      onClick={() =>
                        window.open(
                          'https://blog.gigi.tokyo/category/case/premium_ticket/',
                          '_blank'
                        )
                      }
                      className={classes.btnBottom}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/text-logo2.svg`}
                        alt="さきめし"
                        className={classes.iconButton}
                      />
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="default"
                      onClick={() =>
                        window.open(
                          'https://bizmeshi.jp/for-restaurant',
                          '_blank'
                        )
                      }
                      className={classes.btnBottom}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/text-logo3.svg`}
                        alt="社食ごちめし"
                        className={classes.iconButton}
                      />
                    </Button>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="default"
                      onClick={() =>
                        window.open('https://kodomo-gochimeshi.org/', '_blank')
                      }
                      className={classes.btnBottom}
                    >
                      <img
                        src={`${process.env.PUBLIC_URL}/images/text-logo4.svg`}
                        alt="kodomo"
                        className={classes.iconButton2}
                      />
                    </Button>
                  </div>
                </>
              )}
              {/* <div>
                <br />
                さきめしは、ごちめしの機能を使ってコロナショックに苦しむ飲食店を応援するサービスです。
                <br />
                ごちめしについて知りたい方は
                <Link
                  href="https://docs.google.com/document/d/1Ogk973Kx_uacU9PSDNUUKSLxcAZcCM-RgcAVCzxJJ3s/edit?usp=sharing"
                  target="_blank"
                  className={classes.link}
                >
                  こちら
                </Link>
              </div> */}
            </>
          )}
          <ProgressDialog
            openProgress={openProgress}
            progressOkAction={progressOkAction}
            loading={loading}
            resultMessage={resultMessage}
          />
        </div>
        <Box mt={6}>
          <PublicFooter />
        </Box>
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(login));
